import { sort_center_api } from '@shared/api';

function cleanScannerCode(value: string): string {
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\x00-\x1F\x7F]/g, '');
}

// Гейтвей отдаёт 204, если этикетки нет. Отдельного клейма, в отличие от AZ, не требуется.
export async function getGeParcelLabel(trackNumber: string): Promise<Blob> {
  const cleanTrackNumber = cleanScannerCode(trackNumber);
  const url = `v2/parcels/${encodeURIComponent(cleanTrackNumber)}/label`;

  const response = await sort_center_api.get(url, {
    params: { countryCode: 'GE' },
    responseType: 'blob',
  });

  return new Blob([response.data], { type: 'application/pdf' });
}
